const sectionTeam = () => {
    const teamSection = document.querySelector('#team');
    if (!teamSection) {
        return;
    }

    const dropdowns = teamSection.querySelectorAll('.dropdown');

    dropdowns.forEach(dropdown => {
        dropdown.addEventListener('show.bs.dropdown', event => {
            const column = event.target.closest('[class*="col-"]');
            if (column) {
                column.style.position = 'relative';
                column.style.zIndex = '1000';
            }
        });

        dropdown.addEventListener('hide.bs.dropdown', event => {
            const column = event.target.closest('[class*="col-"]');
            if (column) {
                column.style.position = '';
                column.style.zIndex = '';
            }
        });
    });
};

export default sectionTeam;
